function thumbnailSlider(options, slides) {
    if (typeof jQuery == 'undefined') {
        throw new Error("ThumbNail Slider : JQuery bulunamadı");
    }
    if (typeof(options) == "undefined") {
        throw new Error("ThumbNail Slider : Opsiyon belirtilmeli");
    }
	if (typeof(slides) == "undefined") {
        throw new Error("ThumbNail Slider : Slides belirtilmeli");
    }
	slides = slides || [];
	
    this.options = {
        target: null,
        source: null,
        width: -1,
        height: 300,
        smallHeight: 50,
        smallWidth: 50,
        textHeight: 40,
        waitTime: 5000,
        animSpeed: 200,
        textFont: null,
        textFontSize: -1,
        set: function(param, value) {
            if (!this.hasOwnProperty(param)) {
                return;
            }
            var val = this[param];
            try {
                if (param == "textFont") {
                    this.textFont = value;
                } else {
                    this[param] = parseInt(value, 10);
                }
            } catch (err) {
                this[param] = val;
            }
        }
    }

    function setOptions(options, base) {
        for (var key in options) {
            if (base.options.hasOwnProperty(key)) {
                base.options[key] = options[key];
            }
        }
    }
    setOptions(options, this);
    if (options.target == null) {
        throw new Error("ThumbNail Slider : Target belirtilmeli");
    } 

    function SlideItemsReady(base) {
        var main = $("<div class='reform-thumbnailslider'></div>");
        main.append($("<ul class='big-container'></ul>"));
        main.append($("<ul class='small-container'></ul>"));
        for (var index in base.slideItems) {
            main.children(".big-container").append(base.slideItems[index].bigImage);
            main.children(".small-container").append(base.slideItems[index].smallImage);
        }
        base.options.target.append(main);
        base.main = main;
        base.resize({});
        animateInit(base);
    }
    this.interval = null;

    function animateInit(base) {
        if (base.interval != null) {
            clearInterval(base.interval);
        } else {
            base.move(base.getNextItem());
        }
        if (base.slideItems.length > 1) {
            base.interval = window.setInterval(function() {
                base.move(base.getNextItem())
            }, base.options.waitTime);
        }
    }
    this.currentItem = null;
    this.getNextItem = function() {
        return this.currentItem == null || (this.currentItem.id == (this.slideItems.length - 1)) ? this.slideItems[0] : this.slideItems[this.currentItem.id + 1];
    };
    this.hoverState = false;
    this.animState = false;
    this.move = function(slideItem) {
        if (!this.hoverState) {
            this.animState = true;
            slideItem.bigImage.setShow();
            this.currentItem = slideItem;
        }
    };
    this.resize = function(options) {
        setOptions(options, this);
        var targetWidth = this.options.target.width();
        if (this.options.width !== -1) {
            targetWidth = setSize(this.options.target, "width", this.options.width);
        }
        var mainWidth = setSize(this.main, "width", targetWidth);
        var bigContainerWidth = setSize(this.main.children(".big-container"), "width", mainWidth);
        var bigContainerLiWidth = setSize(this.main.children(".big-container").children("li"), "width", bigContainerWidth);
        var bigContainerLiAWidth = setSize(this.main.children(".big-container").children("li").children("a"), "width", bigContainerLiWidth);
        var bigLabelContainerWidth = setSize(this.main.children(".big-container").find(".thumbnailslider-label"), "width", bigContainerLiAWidth);
        var smallContainerWidth = setSize(this.main.children(".small-container"), "width", mainWidth);
        var smallLiWidth = setSize(this.main.children(".small-container").children("li"), "width", this.options.smallWidth);
        var smallLiAWidth = setSize(this.main.children(".small-container").children("li").children("a"), "width", smallLiWidth);
        var targetHeight = setSize(this.options.target, "height", this.options.height);
        var mainHeight = setSize(this.main, "height", targetHeight);
        var smallContainerHeight = setSize(this.main.children(".small-container"), "height", this.options.smallHeight);
        var labelHeight = setSize(this.main.children(".big-container").find(".thumbnailslider-label"), "height", this.options.textHeight);
        var smallLiHeight = setSize(this.main.children(".small-container").children("li"), "height", smallContainerHeight);
        var smallLiAHeight = setSize(this.main.children(".small-container").children("li").children("a"), "height", smallLiHeight);
        var bigContainerHeight = setSize(this.main.children(".big-container"), "height", mainHeight - this.options.smallHeight);
        var bigContainerLiHeight = setSize(this.main.children(".big-container").children("li"), "height", bigContainerHeight);
        var bigContainerLiAHeight = setSize(this.main.children(".big-container").children("li").children("a"), "height", bigContainerLiHeight);
        this.main.children(".big-container").find("img").data("target", {
            width: bigContainerLiAWidth,
            height: bigContainerLiAHeight
        });
        if (!this.main.children(".big-container").find("img").data("source")) {
            this.main.children(".big-container").find("img").data("source", {
                loaded: false
            });
        }
        this.main.children(".small-container").find("img").data("target", {
            width: smallLiAWidth,
            height: smallLiAHeight
        });
        if (!this.main.children(".small-container").find("img").data("source")) {
            this.main.children(".small-container").find("img").data("source", {
                loaded: false
            });
        }
        this.main.children(".big-container").find(".thumbnailslider-label").css("margin-top", (bigContainerLiAHeight - this.options.textHeight) + "px");
        for (var index in this.slideItems) {
            this.slideItems[index].resize("big");
            this.slideItems[index].resize("small");
        }
    };

    function getOffset(operator, yatay, element) {
        if (element.length > 1) {
            element = $(element[0]);
        }
        if (typeof(yatay) != "boolean") {
            yatay = true;
        }
        var prefix = ["left", "right"];
        if (yatay === false) {
            var prefix = ["top", "bottom"];
        }
        var padding = 0;
        prefix.map(function(alt_prefix) {
            padding += !parseInt(element.css(operator + "-" + alt_prefix), 10) ? 0 : parseInt(element.css(operator + "-" + alt_prefix), 10);
        });
        return padding;
    }

    function setSize(element, prefix, size) {
        var checkValues = ["border", "padding", "margin"];
        var yatay = true;
        if (prefix == "height") {
            yatay = false;
        }
        checkValues.map(function(check_prefix) {
            size = size - getOffset(check_prefix, yatay, element);
        });
        element.css(prefix, size + "px");
        return size;
    }

    function SlideItem(big, small, label, href, target, base) {
        this.big = big;
        this.small = small;
        this.label = label;
        this.href = href;
        this.target = target;
        this.base = base;
        this.id = base.slideItems.length;
        var _slideItem = this;
        if (this.label == "") {
            this.bigImage = $("<li><a class='thumbnailslider-big' href='" + this.href + "' target='" + this.target + "'><img src='" + this.big + "' alt='" + this.label + "' /></a></li>");
        } else {
            this.bigImage = $("<li><a class='thumbnailslider-big' href='" + this.href + "' target='" + this.target + "'><img src='" + this.big + "' alt='" + this.label + "' /><div class='thumbnailslider-label'>" + this.label + "</div></a></li>");
        }
        this.smallImage = $("<li><a class='thumbnailslider-small' href='" + this.href + "' target='" + this.target + "'><img src='" + this.small + "' alt='" + this.label + "' /></a></li>");
        this.bigImage.base = this;
        this.bigImage.parent = base;
        this.smallImage.base = this;
        if (base.options.textFont != null || base.options.textFont != "") {
            this.bigImage.find(".thumbnailslider-label").css("font-family", "'" + base.options.textFont + "'");
        }
        if (base.options.textFontSize != null || base.options.textFontSize != -1) {
            this.bigImage.find(".thumbnailslider-label").css("font-size", base.options.textFontSize + "px");
        }
        this.smallImage.data("base", this);
        this.smallImage.data("parentBase", this.base);
        this.bigImage.data("parentBase", this.base);
        this.bigImage.data("base", this);
        this.onload = function(prefix, image) {
            var a = $(image).data("source");
            a.width = image.width;
            a.height = image.height;
            a.loaded = true;
            $(image).data("source", a);
            _slideItem.resize(prefix, image);
        };
        this["z-index"] = (!parseInt(this.bigImage.css("z-index"), 10) ? 0 : parseInt(this.bigImage.css("z-index"), 10));
        this.resize = function(prefix) {
            var image;
            if (prefix == "big") {
                image = $(this.bigImage.find("img")[0]);
            }
            if (prefix == "small") {
                image = $(this.smallImage.find("img")[0]);
            }
            var context = image.data();
            if (context.source.loaded) {
                imageResizer.resize(image, context.target);
            }
        }
        this.bigImage.find("img")[0].onload = function() {
            $(this).attr("origwidth", this.width);
            $(this).attr("origHeight", this.height);
            this.base.onload("big", this);
        }
        this.bigImage.find("img")[0].base = this;
        this.smallImage.find("img")[0].onload = function() {
            $(this).attr("origwidth", this.width);
            $(this).attr("origHeight", this.height);
            this.base.onload("small", this);
        }
        this.smallImage.find("img")[0].base = this;
        this.bigImage.setShow = function() {
            $(".active-small").removeClass("active-small");
            this.base.smallImage.addClass("active-small");
            $(".active-big").removeClass("active-big").css("z-index", this.base["z-index"]).clearQueue().animate({
                opacity: 0
            }, this.parent.options.animSpeed);
            this.base.bigImage.addClass("active-big").css("z-index", (this.base["z-index"] + 1)).clearQueue().animate({
                opacity: 1
            }, this.parent.options.animSpeed);
        };
        this.bigImage.css("opacity", 0);
        this.smallImage
            .on('mouseenter', function() {
                $(this).data("parentBase").move($(this).data("base"));
                $(this).data("parentBase").hoverState = true;
                return false;
            })
            .on('mouseleave', function() {
                $(this).data("parentBase").hoverState = false;
            });
        this.bigImage
            .on('mouseenter',function() {
                $(this).data("parentBase").move($(this).data("base"));
                $(this).data("parentBase").hoverState = true;
                return false;
            })
            .on('mouseleave', function() {
                $(this).data("parentBase").hoverState = false;
            });
    }
    SlideItem.base = this;
	var base = this;
	base.slideItems = [];
	slides.forEach(function(slide){
        base.slideItems.push(new SlideItem(slide.picture, slide.kpicture, slide.label, slide.href, slide.target, base));
	});
	if (base.slideItems.length != 0) SlideItemsReady(base);
}
$.fn.extend({
    thumbnailSlider: function(options, slides) {
        if (typeof(options) == "undefined") {
            options = {};
            options.target = $(this);
        }
        if (!options.hasOwnProperty("target")) {
            options.target = $(this);
        }
        if ($(this).data("base")) {
            $(this).data("base").resize(options);
        } else {
            $(this).data("base", new thumbnailSlider(options, slides));
        }
        return $(this);
    }
});
var thumbnailSettings;
if (thumbnailSettings = $("#thumbnail_slider_source").html()) {
	thumbnailSettings = $(thumbnailSettings);
	var options = {};
	thumbnailSettings.find("settings").text().split('&1001001&').map(function(kv){ return { key: kv.split('=')[0], value: kv.split('=')[1] }; }).forEach(function(s){ 
		options[s.key] = (s.key == "textFont" ? s.value : parseInt(s.value, 10));
	});
	var slides = thumbnailSettings.find("banner").toArray().map(function(e) {
		return { 
			picture: $(e).find("picture").text().split('&1001001&')[0],
			kpicture: $(e).find("picture").text().split('&1001001&')[1],
			label: $(e).find("picture").text().split('&1001001&')[2],
			href: $(e).find("href").text(),
			target: $(e).find("target").text()
		};
	});
	$("#PM_xml_banner").thumbnailSlider(options, slides);
}
$("#thumbnailSlider-init").remove();
var imageResizer = {
    defaultOptions: {
        width: 0,
        height: 0,
        keepRatio: true,
        expand: true,
    },
    parseOptions: function(options) {
        var parsedOptions = {};
        for (var name in this.defaultOptions) {
            parsedOptions[name] = this.defaultOptions[name];
        }
        if (typeof(options) != "object") {
            return parsedOptions;
        }
        for (var name in options) {
            if (parsedOptions.hasOwnProperty(name)) {
                parsedOptions[name] = options[name];
            }
        }
        return parsedOptions;
    },
    checkAttr: function(element) {
        if (!element.attr("origwidth")) {
            element.attr("origwidth", element.width() == 0 ? parseInt(element.attr("width"), 10) : element.width());
        }
        if (!element.attr("origheight")) {
            element.attr("origheight", element.height() == 0 ? parseInt(element.attr("height"), 10) : element.height());
        }
        return element;
    },
    getOrginalSize: function(element) {
        return {
            width: parseInt(element.attr("origwidth"), 10),
            height: parseInt(element.attr("origheight"), 10)
        };
    },
    analyzeEdge: function(size) {
        if (size.width >= size.height) {
            return {
                tall: "width",
                short: "height",
            };
        }
        if (size.width < size.height) {
            return {
                tall: "height",
                short: "width"
            };
        }
    },
    convertwidth: function(size, newHeight) {
        if (typeof(size) != "object" && typeof(newHeight) != "number") {
            return 0;
        }
        if (!size.hasOwnProperty("width") && !size.hasOwnProperty("height")) {
            return 0;
        }
        return (size.width / size.height) * newHeight;
    },
    convertheight: function(size, newWidth) {
        if (typeof(size) != "object" && typeof(newWidth) != "number") {
            return 0;
        }
        if (!size.hasOwnProperty("width") && !size.hasOwnProperty("height")) {
            return 0;
        }
        return (size.height / size.width) * newWidth;
    },
    convertEdge: function(edgeName, size, newSize) {
        return eval("imageResizer.convert" + edgeName + "(size, newSize);");
    },
    calculateIn: function(element, options) {
        if (!options.keepRatio) {
            return {
                width: options.width,
                height: options.height
            };
        }
        var orginalSize = this.getOrginalSize(element);
        var orginalEdge = this.analyzeEdge(orginalSize);
        if (options.width != 0 && options.height != 0) {
            var targetAnlyze = this.analyzeEdge(options);
            var orginalAnlyze = this.analyzeEdge(orginalSize);
            var calc = {};
            calc[targetAnlyze.tall] = this.convertEdge(targetAnlyze.tall, orginalSize, options[targetAnlyze.short]);
            calc[targetAnlyze.short] = this.convertEdge(targetAnlyze.short, orginalSize, options[targetAnlyze.tall]);
            if (calc.width == options.width) {
                options.width = calc.width;
                options.height = calc.height;
            }
            if (!options.expand) {
                if (calc.width > options.width) {
                    options.height = calc.height;
                }
                if (calc.width < options.width) {
                    options.width = calc.width;
                }
            } else {
                if (calc.width < options.width) {
                    options.height = calc.height;
                }
                if (calc.width > options.width) {
                    options.width = calc.width;
                }
            }
        }
        if (options.width == 0) {
            options.width = this.convertwidth(orginalSize, options.height);
        }
        if (options.height == 0) {
            options.height = this.convertheight(orginalSize, options.width);
        }
        return options;
    },
    resize: function(imgElement, options) {
        var options = this.parseOptions(options);
        if (imgElement == false || (options.width == 0 && options.height == 0)) {
            return undefined;
        }
        if (imgElement[0].nodeName != "IMG") {
            return undefined;
        }
        imgElement = this.checkAttr(imgElement);
        newSize = this.calculateIn(imgElement, options);
        imgElement.css("width", newSize.width + "px");
        imgElement.css("height", newSize.height + "px");
        return imgElement;
    }
};